import { render, staticRenderFns } from "./GOPerformance.vue?vue&type=template&id=50cc066e&scoped=true&"
import script from "./GOPerformance.vue?vue&type=script&lang=js&"
export * from "./GOPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc066e",
  null
  
)

export default component.exports